import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const EICCodeCreate = yup.object().shape({
    name: yup.string().required(ERRORS.required),
    EICCode: yup.string().required(ERRORS.required),
    AFRRConfig: yup.boolean().required(ERRORS.required),
    MFRRConfig: yup.boolean().required(ERRORS.required),
    AFRR: yup.object().shape({
        monitoring: yup
            .boolean()
            .when('$AFRRConfig', {
                is: true,
                then: (schema) => schema.required(ERRORS.required),
                otherwise: (schema) => schema.optional(),
            }),

        redisConfig: yup.object().shape({
            host: yup
                .string()
                .when('$AFRRConfig', {
                    is: true,
                    then: (schema) => schema.required(ERRORS.required),
                    otherwise: (schema) => schema.optional(),
                }),
            port: yup
                .number()
                .when('$AFRRConfig', {
                    is: true,
                    then: (schema) => schema.required(ERRORS.required),
                    otherwise: (schema) => schema.optional(),
                }),
            password: yup.string().optional(),
        }),
    }),

    MFRR: yup.object().shape({
        monitoring: yup
            .boolean()
            .when('$MFRRConfig', {
                is: true,
                then: (schema) => schema.required(ERRORS.required),
                otherwise: (schema) => schema.optional(),
            }),

        redisConfig: yup.object().shape({
            host: yup
                .string()
                .when('$MFRRConfig', {
                    is: true,
                    then: (schema) => schema.required(ERRORS.required),
                    otherwise: (schema) => schema.optional(),
                }),
            port: yup
                .number()
                .when('$MFRRConfig', {
                    is: true,
                    then: (schema) => schema.required(ERRORS.required),
                    otherwise: (schema) => schema.optional(),
                }),
            password: yup.string().optional(),
        }),
    }),
});
